import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
// import "./App.css";
import MemberInfoCard, {
  ClickType as MemberInfoNumClickType,
} from "./components/MemberInfoCard";
import styles from "./App.module.scss";
import PointsAndCoupons, {
  CouponItem,
  PointItem,
} from "./components/PointsAndCoupons";
import { useRequest } from "ahooks";
import { memberRequest, sendMessageToParent } from "./utils";
import {
  getCustomerCouponsListApi,
  getCustomerPointsListApi,
  getDiscountListApi,
  getGiftCardListApi,
} from "./urls";
import {
  AvailableGiftCardItem,
  DISCOUNT_STATUS,
  GIFT_CARD_STATUS,
} from "./constants";

import "./App.css";
import { IDiscountItem } from "./types";
import { IGiftCardItem } from "./components/PointsAndCoupons/components/GiftCardItem";

function App() {
  const [customerId, setCustomerId] = useState<number>(0);
  const [userName, setUserName] = useState<string>("");
  const [totalPoints, setTotalPoints] = useState<number>(0);
  const [totalSaved, setTotalSaved] = useState<number>(0);

  const pointAndCouponsRef = useRef<any>(null);

  // 获取会员积分列表
  const { run: fetchCustomerPointsList, data: customerPointsListData } =
    useRequest(
      async ({ memberId }: { memberId: number }) => {
        const params = {
          customer_id: memberId,
          current_page: 1,
          page_size: 10000,
        };

        return memberRequest({
          url: getCustomerPointsListApi,
          method: "GET",
          params,
        });
      },
      {
        manual: true,
      }
    );

  // 获取会员折扣列表
  const { run: fetchDiscountList, data: discountListData } = useRequest(
    async ({ memberId }: { memberId: number }) => {
      const params = {
        customer_id: memberId,
        current_page: 1,
        page_size: 10000,
      };

      return memberRequest({
        url: getDiscountListApi,
        method: "GET",
        params,
      });
    },
    {
      manual: true,
    }
  );

  // 获取会员 gift card 列表
  const { run: fetchGiftCardList, data: giftCardListData } = useRequest(
    async ({ memberId }: { memberId: number }) => {
      const params = {
        customer_id: memberId,
        current_page: 1,
        page_size: 10000,
      };

      return memberRequest({
        url: getGiftCardListApi,
        method: "GET",
        params,
      });
    },
    {
      manual: true,
    }
  );
  // 获取会员优惠券
  const { run: fetchCustomerCouponsList, data: customerCouponsListData } =
    useRequest(
      async ({ memberId }: { memberId: number }) => {
        const params = {
          customer_id: memberId,
          current_page: 1,
          page_size: 10000,
        };

        return memberRequest({
          url: getCustomerCouponsListApi,
          method: "GET",
          params,
        });
      },
      {
        manual: true,
      }
    );

  const pointsList: PointItem[] = useMemo(() => {
    return customerPointsListData?.data?.data?.total_list || [];
  }, [customerPointsListData]);

  const discountList: IDiscountItem[] = useMemo(() => {
    // discount_code_type 3 为折扣券
    // discount_code_type 2 为免邮券
    return (
      (discountListData?.data?.data?.total_list as IDiscountItem[])?.filter(
        (item) =>
          (item.discount_code_type === 3 || item.discount_code_type === 2) &&
          item.status === DISCOUNT_STATUS.AVAILABLE
      ) || []
    );
  }, [discountListData]);

  const giftCardsList: IGiftCardItem[] = useMemo(() => {
    return (giftCardListData?.data?.data?.total_list || []).filter(
      (item: IGiftCardItem) =>
        item.status === GIFT_CARD_STATUS.AVAILABLE && item.current_value > 0
    );
  }, [giftCardListData]);

  const couponsList: CouponItem[] = useMemo(() => {
    console.log(">>>> customerCouponsListData:", customerCouponsListData);
    return customerCouponsListData?.data?.data?.total_list || [];
  }, [customerCouponsListData]);

  // const totalCoupons = useMemo(() => {
  //   return couponsList.filter((item) => item.status === COUPON_STATUS.AVAILABLE)
  //     .length;
  // }, [couponsList]);

  const handleNumberClick = useCallback((type: MemberInfoNumClickType) => {
    if (type === "totalSaved") {
      sendMessageToParent({
        type: "scroll-to-sidebar",
        data: {},
      });
    }
  }, []);

  useEffect(() => {
    if (!customerId) return;

    fetchCustomerPointsList({ memberId: customerId });
    fetchCustomerCouponsList({ memberId: customerId });
  }, [fetchCustomerCouponsList, fetchCustomerPointsList, customerId]);

  // 获取会员折扣列表
  useEffect(() => {
    if (!customerId) return;
    fetchDiscountList({ memberId: customerId });
  }, [customerId, fetchDiscountList]);

  const handleRedeem = useCallback(
    (data: AvailableGiftCardItem) => {
      console.log(">>>> data:", data);
      sendMessageToParent({
        type: "member-toast",
        data: {
          type: "success",
          message: "Redeemed Successfully!",
          duration: 3000,
        },
      });

      // 确保 customerId 存在后再刷新数据
      if (customerId) {
        // 刷新积分列表
        fetchCustomerPointsList({ memberId: customerId });
        // 刷新折扣列表
        fetchDiscountList({ memberId: customerId });
      }

      sendMessageToParent({
        type: "scroll-to",
        data: {
          ...pointAndCouponsRef.current?.getElementPosition(),
        },
      });
    },
    [fetchCustomerPointsList, fetchDiscountList, customerId]
  );

  // 通知 shopify，页面已经加载完成
  useEffect(() => {
    sendMessageToParent({ type: "member-page-loaded" });
  }, []);

  // 监听 shopify 的消息
  useEffect(() => {
    window.addEventListener("message", (event) => {
      const { data } = event;
      if (data.type === "init-data") {
        const { customerId, userName } = data.data;
        console.log(">>>> init-data:", customerId);
        setCustomerId(customerId);
        setUserName(userName);
        // 根据 customerId 处理跳转逻辑 -------------------------------->
        // const customerIdInLocalStorage = localStorage.getItem("customerId");

        // console.log(">>>> customerIdInLocalStorage:", customerIdInLocalStorage);

        // if (customerId) {
        //   localStorage.setItem("customerId", customerId.toString());
        // } else {
        //   // 未登录、未注册，跳去注册
        //   if (!customerIdInLocalStorage) {
        //     sendMessageToParent({ type: "goto", url: "/account/register" });
        //   } else {
        //     // 未登录、已注册，跳去登录页
        //     sendMessageToParent({ type: "goto", url: "/account/login" });
        //   }
        // }
      }
    });
  }, []);

  // 处理埋点
  useEffect(() => {
    const handleClick = (event: MouseEvent) => {
      const target = (event.target as HTMLElement)?.closest(
        "[data-element-id]"
      );
      if (!target) {
        console.log("没有找到目标元素");
        return;
      }

      // 明确使用 data-element-id 的值
      const elementId = (target as HTMLElement).dataset.elementId;
      console.log("当前元素ID:", elementId);

      // 埋点
      elementId &&
        sendMessageToParent({
          type: "send-datac",
          data: {
            elementId,
          },
        });
    };

    document.addEventListener("click", handleClick);

    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, []);

  // iframe ready
  useEffect(() => {
    sendMessageToParent({ type: "iframe-ready" });
  }, []);

  // 获取会员 gift card 列表
  useEffect(() => {
    if (!customerId) return;
    fetchGiftCardList({ memberId: customerId });
  }, [customerId, fetchGiftCardList]);

  // 计算会员总积分
  useEffect(() => {
    const points = pointsList.reduce((acc, curr) => acc + curr.total_points, 0);
    setTotalPoints(points);
  }, [pointsList]);

  // 计算总节省金额
  useEffect(() => {
    const saved = pointsList.reduce(
      (acc, curr) => acc + curr.total_save_amount,
      0
    );
    setTotalSaved(saved);
  }, [pointsList]);

  // 每隔 2 秒刷新一次 积分数据，使用 setTimeout 实现
  useEffect(() => {
    if (!customerId) return;

    const scheduleNext = () => {
      const timeoutId = setTimeout(() => {
        fetchCustomerPointsList({ memberId: customerId });
        scheduleNext();
      }, 2000);
      return timeoutId;
    };

    const timeoutId = scheduleNext();

    return () => clearTimeout(timeoutId);
  }, [customerId, fetchCustomerPointsList]);

  return (
    <div className={styles.memberContainer}>
      <MemberInfoCard
        points={totalPoints}
        totalSaved={totalSaved}
        username={userName}
        isLogin={!!customerId}
        onClick={handleNumberClick}
      />

      <PointsAndCoupons
        ref={pointAndCouponsRef}
        points={pointsList}
        coupons={couponsList}
        discountCards={discountList}
        giftCards={giftCardsList}
        onRedeem={handleRedeem}
        customerId={customerId}
      />
    </div>
  );
}

export default App;
